import { ILayout } from "@interfaces";

import { StyledAppLayout, MainContent, Sidebar, MenuToggleButton, MenuOverlay } from ".";
import { AppTopBar, MenuComponent, DebugPanel } from "@components";
import { debugLog } from "@utils";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export const AppLayout = (props: ILayout) => {
  const { children } = props;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const hiddenPaths = ["/login", "/fogot-password"];

  // 検証用: 画面遷移を記録する（dev環境限定）
  useEffect(() => {
    debugLog("info", "画面遷移", `${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return (
    <StyledAppLayout>
      {!hiddenPaths.includes(location.pathname) &&
        <Sidebar isOpen={isSidebarOpen}>
          <MenuComponent onNavigate={() => setIsSidebarOpen(false)} />
        </Sidebar>
      }

      {/* メニューを開いているときだけ背景を出し、タップで閉じられるようにする */}
      {!hiddenPaths.includes(location.pathname) && isSidebarOpen &&
        <MenuOverlay onClick={() => setIsSidebarOpen(false)} />
      }

      {!hiddenPaths.includes(location.pathname) ? (
        <MainContent>
          <MenuToggleButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>☰</MenuToggleButton>
          <AppTopBar />
          {children}
        </MainContent>
      ) : (
        <>
          {children}
        </>
      )}
      <DebugPanel />
    </StyledAppLayout>
  );
};
